import { Box, Grid, Typography, Divider, TextField, FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox, Button, InputLabel, MenuItem, Select } from '@mui/material';
import { TypeRisrot } from '../../../../pages/Reports/Risrot/RegisterRisrot';
import { HourglassBottom, LocalDining, Search } from '@mui/icons-material';


interface FichaRISROT {
	onChange: (name: keyof TypeRisrot, value: string | boolean) => void;
	data?: TypeRisrot;
	disabled?: boolean;
	loadingData: boolean;
	ristotID: string;
	handleBuscaCabecalho: () => void;
	maiorNPA: 'Normal' | 'Alerta' | 'Atenção' | 'Emergência';
	handleUpdateNPGB: (value: string) => void;
}

const npaOpcoes = [
	{ valor: 'Normal', prioridade: 0 },
	{ valor: 'Alerta', prioridade: 1 },
	{ valor: 'Atenção', prioridade: 2 },
	{ valor: 'Emergência', prioridade: 3 }
] as const;

const npaHierarquia: Record<'Normal' | 'Alerta' | 'Atenção' | 'Emergência', number> = {
	'Normal': 0,
	'Alerta': 1,
	'Atenção': 2,
	'Emergência': 3
};

export default function FichaRisrot({ onChange, data, disabled, loadingData, ristotID, handleBuscaCabecalho, maiorNPA, handleUpdateNPGB }: FichaRISROT) {

	return (
		<Box>
			<Grid container spacing={2} padding={2}>
				<Grid item xs={12}>
					<Typography variant='h5'>Ficha de inspeção de Barragem</Typography>
					<Divider />
				</Grid>
				<Grid item xs={6}>
					<TextField
						label='Data de inspeção'
						fullWidth
						InputLabelProps={{ shrink: true }}
						type='date'
						onChange={(e) => onChange('data_inspecao', e.target.value)}
						value={data?.data_inspecao}
						disabled={ristotID !== 'new'}
					/>
				</Grid>
				<Grid item xs={2}>
					<TextField
						label='Hora de inicio'
						fullWidth
						InputLabelProps={{ shrink: true }}
						disabled={ristotID !== 'new'}
						type='time'
						value={data?.hora_inicio_inspecao}
						onChange={(e) => onChange('hora_inicio_inspecao', e.target.value)}
					/>
				</Grid>
				<Grid item xs={2}>
					<TextField
						label='Hora de fim'
						fullWidth
						InputLabelProps={{ shrink: true }}
						disabled={ristotID !== 'new'}
						type='time'
						value={data?.hora_fim_inspecao}
						onChange={(e) => onChange('hora_fim_inspecao', e.target.value)}
					/>
				</Grid>
				<Grid item xs={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<Button
						variant='contained'
						startIcon={loadingData ? <HourglassBottom /> : <Search />}
						disabled={ristotID !== 'new'}
						onClick={handleBuscaCabecalho}
					>
						Buscar
					</Button>
				</Grid>
				{/* {loadingData &&
					<Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', width: '100%', flexDirection: 'row', gap: 2 }}>
						<CircularProgress />
						<Typography>Carregando dados...</Typography>
					</Grid>
				} */}
				<Grid item xs={6}>
					<TextField
						label='Estrutura'
						disabled={true}
						fullWidth
						onChange={(e) => onChange('nome_estrutura', e.target.value)}
						value={data?.nome_estrutura}
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label='Localização'
						disabled={true}
						fullWidth
						value={data?.localizacao}
						onChange={(e) => onChange('localizacao', e.target.value)}
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label='Empreendedor'
						disabled={true}
						fullWidth
						value={data?.empreendedor}
						onChange={(e) => onChange('empreendedor', e.target.value)}
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label='Tipo do Barramento'
						disabled={true}
						fullWidth
						value={data?.tipo_barramento}
						onChange={(e) => onChange('tipo_barramento', e.target.value)}
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label='Data da última inspeção'
						fullWidth
						value={data?.data_ultima_inspecao}
						disabled={true}
						onChange={(e) => onChange('data_ultima_inspecao', e.target.value)}
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label='Código do cliente'
						fullWidth
						value={data?.codigo_cliente}
						disabled={ristotID !== 'new'}
						onChange={(e) => onChange('codigo_cliente', e.target.value)}
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label='Código do HIDROBR'
						fullWidth
						value={data?.codigo_hidrobr}
						disabled={ristotID !== 'new'}
						onChange={(e) => onChange('codigo_hidrobr', e.target.value)}
					/>
				</Grid>
				<Grid item xs={6}>
					<FormControl fullWidth disabled={disabled}>
						<InputLabel>NPGB</InputLabel>
						<Select
							value={maiorNPA}
							label="NPA"
							onChange={(e) => handleUpdateNPGB(e.target.value)}
							disabled={ristotID !== 'new'}
						>
							{npaOpcoes
								.filter(opcao => npaHierarquia[opcao.valor] >= npaHierarquia[maiorNPA])
								.map((opcao) => (
									<MenuItem key={opcao.valor} value={opcao.valor}>
										{opcao.valor}
									</MenuItem>
								))
							}
						</Select>
					</FormControl>

				</Grid>
				<Grid item xs={6}>
					<FormControl>
						<FormLabel>Em operação ?</FormLabel>
						<FormGroup row>
							<FormControlLabel
								control={<Checkbox disabled={ristotID !== 'new'} checked={data?.em_operacao == 'Sim'} onChange={() => onChange('em_operacao', 'Sim')} />}
								label='Sim'
								labelPlacement='end'
							/>
							<FormControlLabel
								control={<Checkbox disabled={ristotID !== 'new'} checked={data?.em_operacao == 'Não'} onChange={() => onChange('em_operacao', 'Não')} />}
								label='Não'
								labelPlacement='end'
							/>
						</FormGroup>
					</FormControl>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label='Responsável pela inspeção'
						fullWidth
						disabled={ristotID !== 'new'}
						onChange={(e) => onChange('responsavel_inpecao', e.target.value)}
						value={data?.responsavel_inpecao}
					/>
				</Grid>
				<Grid item xs={12}>
					<TextField
						label='Realizadores da inspeção'
						fullWidth
						disabled={ristotID !== 'new'}
						multiline
						rows={3}
						value={data?.executores_inspecao}
						onChange={(e) => onChange('executores_inspecao', e.target.value)}
					/>
				</Grid>
				<Grid item xs={12}>
					<Typography variant='h6'>Condições da inspeção</Typography>
					<Divider />
				</Grid>
				<Grid item xs={6}>
					<FormControl>
						<FormLabel>Condição climática (no dia da visita)</FormLabel>
						<FormGroup row>
							<FormControlLabel
								control={<Checkbox disabled={ristotID !== 'new'} checked={data?.condicao_climatica == 'Ensolarado'} onChange={() => onChange('condicao_climatica', 'Ensolarado')} />}
								label='Ensolarado'
								labelPlacement='end'
							/>
							<FormControlLabel
								control={<Checkbox disabled={ristotID !== 'new'} checked={data?.condicao_climatica == 'Nublado'} onChange={() => onChange('condicao_climatica', 'Nublado')} />}
								label='Nublado'
								labelPlacement='end'
							/>
							<FormControlLabel
								control={<Checkbox disabled={ristotID !== 'new'} checked={data?.condicao_climatica == 'Chuvoso'} onChange={() => onChange('condicao_climatica', 'Chuvoso')} />}
								label='Chuvoso'
								labelPlacement='end'
							/>
						</FormGroup>
					</FormControl>
				</Grid>
				<Grid item xs={6}>
					<FormControl>
						<FormLabel>Sistema de bombeamento operando ?</FormLabel>
						<FormGroup row>
							<FormControlLabel
								control={<Checkbox disabled={ristotID !== 'new'} checked={data?.bombeamento_funcionando == 'Sim'} onChange={() => onChange('bombeamento_funcionando', 'Sim')} />}
								label='Sim'
								labelPlacement='end'
							/>
							<FormControlLabel
								control={<Checkbox disabled={ristotID !== 'new'} checked={data?.bombeamento_funcionando == 'Não'} onChange={() => onChange('bombeamento_funcionando', 'Não')} />}
								label='Não'
								labelPlacement='end'
							/>
							<FormControlLabel
								control={<Checkbox disabled={ristotID !== 'new'} checked={data?.bombeamento_funcionando == 'NA'} onChange={() => onChange('bombeamento_funcionando', 'NA')} />}
								label='NA'
								labelPlacement='end'
							/>
						</FormGroup>
					</FormControl>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label='Nível de água do reservatório (m)'
						fullWidth
						disabled={ristotID !== 'new'}
						onChange={(e) => onChange('na_reservatorio', e.target.value)}
						value={data?.na_reservatorio}
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label='Nível de água máx. do reservatório (m)'
						fullWidth
						disabled={ristotID !== 'new'}
						onChange={(e) => onChange('na_maximo_reservatorio', e.target.value)}
						value={data?.na_maximo_reservatorio}
					/>
				</Grid>
			</Grid>
		</Box>
	);
}